exports.components = {
  "component---src-components-document-body-tsx": () => import("./../../../src/components/DocumentBody.tsx" /* webpackChunkName: "component---src-components-document-body-tsx" */)
}

